/* Submits the sort form on change, and closes an open filter pill when the
   click lands outside it. Both degrade cleanly: without this the form still
   submits from the noscript button and the pills still open and close. */
(() => {
  const init = (root) => {
    if (root.dataset.cmReady) return;
    root.dataset.cmReady = 'true';

    const sort = root.querySelector('[data-cm-sort]');
    sort?.querySelector('select')?.addEventListener('change', () => sort.submit());

    const pills = Array.from(root.querySelectorAll('.cm__filter'));
    if (!pills.length) return;

    document.addEventListener('click', (event) => {
      pills.forEach((pill) => {
        if (!pill.open || pill.contains(event.target)) return;
        pill.open = false;
      });
    });

    root.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape') return;
      const open = event.target.closest('.cm__filter[open]');
      if (!open) return;
      open.open = false;
      open.querySelector('summary')?.focus();
    });
  };

  const scan = (scope) => scope.querySelectorAll('.cm').forEach(init);

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
